import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})


//Class to manage the fetch to the API of the Pick and Go configurations
export class PickNGoFetchAPI {
    //Function to get all Pick and Go configurations by business
    static async getPickAndGoRulesByBusiness(business_id, token) {
        const res = await server(`/pick-and-go?business_id=${business_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }
    //Function to create a Pick and Go configuration
    static async createPickAndGoRule(data, token) {
        const res = await server('/pick-and-go', {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

    //Function to update a Pick and Go configuration
    static async updatePickAndGoRule(id, data, token) {
        const res = await server(`/pick-and-go/${id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

    //Function to delete a Pick and Go configuration
    static async deletePickAndGoRule(id, token) {
        const res = await server(`/pick-and-go/${id}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res
    }
    //Function to get the details of a Pick and Go configuration
    static async getPickAndGoRuleDetails(id, token) {
        const res = await server(`/pick-and-go/${id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to set rule products 
    static async setRuleProducts(pick_and_go_id, data, token) {
        const res = await server(`/pickngo/rules/${pick_and_go_id}/products`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

    //Function to get rule products
    static async getRuleProducts(pick_and_go_id, token) {
        const res = await server(`/pickngo/rules/${pick_and_go_id}/products`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }
    
}